
import CircularProgress from "@mui/material/CircularProgress";
import MaterialButton from "@mui/material/Button";
import React from "react";

const buttonSpinner =
  <CircularProgress
  className="button__spinner"
  size={24}
  color="inherit"
/>;

const Button = (props) => {
  const {
    children,
    working,
    disabled,
    ...rest
  } = props;

  return (
    <MaterialButton {...rest} disabled={disabled || working}>
      {working ? buttonSpinner : children}
    </MaterialButton>
  )
};

export default Button;